package com.havn.app.core.localization

enum class HavnLanguage(
    val code: String,
    val displayName: String,
    val nativeName: String
) {
    English("en", "English", "English"),
    Slovak("sk", "Slovak", "Slovenčina"),
    German("de", "German", "Deutsch"),
    French("fr", "French", "Français"),
    Czech("cs", "Czech", "Čeština"),
    Spanish("es", "Spanish", "Español"),
    Italian("it", "Italian", "Italiano");

    companion object {
        fun fromCode(code: String?): HavnLanguage =
            entries.firstOrNull { it.code == code } ?: English
    }
}
